<template>
  <div class="content">
    <transition name="view" appear enter-active-class="animated fadeIn" leave-active-class="animated slideOutDown">
        <!-- your content here -->
        <router-view></router-view>
    </transition>
  </div>
</template>
<script>
  import {FadeTransition} from 'vue2-transitions';
  export default {
    components: {
      FadeTransition
    }
  };
</script>

